import { useMutation } from 'react-query';
import { httpService } from '../../../services/http.service';
import { BASE_URL, USER } from '../../../constants/endpoints';
import { useStore } from '../../../store';
import { IFetchTransactions } from '../interfaces';

const {
  CONTROLLERS: {
    ACCOUNT: {
      BASE,
      ROUTES: { TRANSACTIONS },
    },
  },
} = USER;

export interface UseFetchTransactionsProps {
  queryParamsString: string;
}
export const useFetchTransactions = () => {
  const { customerId } = useStore((state) => state.user);
  return useMutation('useFetchTransactionsFacelift', async ({ queryParamsString }: UseFetchTransactionsProps) => {
    const { data } = await httpService.get(
      `${BASE_URL}/api/${TRANSACTIONS.VERSION}/user/${customerId}/${BASE}/${TRANSACTIONS.BASE}?${queryParamsString}`,
    );
    return data as IFetchTransactions;
  });
};
